import rfStore from "./rfStore";

export default function hasLogin() {
  return rfStore.getRFState()?.token;
}
